// Zod 4 building blocks for typed route search params: optional values and defaults that fall back (.catch) instead of failing on bad URLs.
import { z } from "zod";

export function optionalString() {
  return z
    .union([z.string(), z.number().transform(String)])
    .pipe(z.string().min(1))
    .optional()
    .catch(undefined);
}

export function optionalNumber(min: number, max: number) {
  return z.number().min(min).max(max).optional().catch(undefined);
}

export function numberWithDefault(fallback: number, min: number, max: number) {
  return z.number().int().min(min).max(max).default(fallback).catch(fallback);
}

export function enumWithDefault<const T extends readonly [string, ...string[]]>(
  values: T,
  fallback: T[number],
) {
  return z.enum(values).default(fallback).catch(fallback);
}

export function optionalEnum<const T extends readonly [string, ...string[]]>(values: T) {
  return z.enum(values).optional().catch(undefined);
}

export function booleanWithDefault(fallback: boolean) {
  return z.boolean().default(fallback).catch(fallback);
}

export function optionalBoolean() {
  return z.boolean().optional().catch(undefined);
}

export function optionalList<S extends z.ZodType<string>>(item: S) {
  return z.array(item).optional().catch(undefined);
}

export function listWithDefault<S extends z.ZodType<string>>(item: S, fallback: z.infer<S>[]) {
  return z.array(item).default(fallback).catch(fallback);
}
